var _rect, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOzoneLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_1345)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#005BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_1345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H200V200H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_1345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4987 100.274L95.5539 88.8664L114.989 75.8303L138.234 77.4303L141.627 88.5801L247.578 202.558L81.8609 252.776L98.4987 100.274Z",
    fill: "#F91155"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2636 133.703C13.743 136.812 5.34101 131.795 4.18108 123.503C3.39025 117.851 6.49655 112.284 11.6233 110.165C19.1442 107.056 27.5458 112.073 28.7061 120.364C29.4965 126.017 26.3902 131.584 21.2636 133.703ZM12.5843 98.401C-1.95075 100.75 -10.4901 116.054 -5.18447 130.248C-1.25894 140.753 9.54642 147.204 20.3022 145.466C34.8378 143.118 43.3768 127.814 38.0716 113.619C34.1456 103.115 23.3401 96.6635 12.5843 98.401V98.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0759 90.1338C41.8087 91.0092 40.0449 94.7186 41.6454 97.9782C42.8191 100.369 45.61 101.468 48.1437 100.789L62.8568 96.8465L48.1822 133.666C47.7008 134.874 48.7953 136.131 50.0393 135.798L85.9551 126.174C88.4887 125.495 90.356 123.147 90.1772 120.49C89.9335 116.867 86.5515 114.537 83.2843 115.413L65.3583 120.216L80.0215 83.4238C80.5076 82.2042 79.403 80.9359 78.1476 81.2723L45.0759 90.1338",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.5 51.4713C186.179 52.6532 185.109 55.418 185.789 57.9563L190.566 75.7835L155.704 60.489C154.488 59.9561 153.207 61.0705 153.552 62.3594L163.414 99.1654C164.094 101.703 166.403 103.563 169.004 103.426C172.632 103.235 174.952 99.8023 174.058 96.466L169.241 78.487L204.103 93.7812C205.318 94.3142 206.6 93.2001 206.254 91.9112L196.357 54.9715C195.463 51.6352 191.736 49.8223 188.5 51.4713",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.63 70.5648C96.1695 75.2434 84.7783 89.3503 88.1876 102.074C91.5967 114.797 108.515 121.319 125.976 116.64C143.436 111.961 154.828 97.8542 151.418 85.1311C148.009 72.4076 131.091 65.8863 113.63 70.5648ZM116.511 81.3174C128.574 78.0852 139.326 82.1559 140.879 87.955C142.433 93.7541 135.158 102.655 123.095 105.887C111.032 109.12 100.28 105.049 98.7263 99.2499C97.1725 93.4508 104.448 84.5498 116.511 81.3174V81.3174Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzoneLogo);
export default __webpack_public_path__ + "static/media/ozoneLogo.824d032a.svg";
export { ForwardRef as ReactComponent };